import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-134e6edf")

_pushScopeId("data-v-134e6edf")
const _hoisted_1 = {
  key: 1,
  class: "checkItemPicture"
}
const _hoisted_2 = {
  key: 2,
  class: "assistDesc"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkTitle = _resolveComponent("checkTitle")
  const _component_checkDescrip = _resolveComponent("checkDescrip")
  const _component_checkContent = _resolveComponent("checkContent")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "ui__checkItem_main",
      id: _ctx.renderData.code
    }, [
      _createVNode(_component_checkTitle, {
        itemCode: _ctx.renderData.code,
        titleCont: _ctx.getData("moduleTitle"),
        count: _ctx.getData("defectCount"),
        allCount: _ctx.getData("itemCount"),
        checkStandardRouter: _ctx.getData("checkStandardRouter"),
        hasDefect: _ctx.hasDefect,
        isExpanded: _ctx.state.isExpanded,
        onToggle: _ctx.toggleExpand
      }, null, 8, ["itemCode", "titleCont", "count", "allCount", "checkStandardRouter", "hasDefect", "isExpanded", "onToggle"]),
      (_ctx.getData('conclusionDesc') && _ctx.state.isExpanded)
        ? (_openBlock(), _createBlock(_component_checkDescrip, {
            key: 0,
            renderData: _ctx.renderData.configItems
          }, null, 8, ["renderData"]))
        : _createCommentVNode("", true),
      (_ctx.getData("exampleImage") && _ctx.state.isExpanded)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("img", {
              src: _ctx.getData("exampleImage")
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_checkContent, {
        renderData: _ctx.state.contRenderData
      }, null, 8, ["renderData"]), [
        [_vShow, _ctx.state.isExpanded]
      ]),
      (_ctx.renderData.code === "accident" && _ctx.state.isExpanded)
        ? (_openBlock(), _createBlock("p", _hoisted_2, "※Ancillary inspection item. Any defects found are for reference only and do not serve as a basis for determining the vehicle as an accident vehicle."))
        : _createCommentVNode("", true)
    ], 8, ["id"]),
    _hoisted_3
  ]))
})